import ModalView from 'common-views/ModalView';
import template  from 'dashboard/forms/modal/apply-permission-to-action.ejs';
import constants from 'Constants';

class ApplyPermissionToActionsModal extends ModalView {

    initialize(){
        super.initialize();
        this.template = template;
        this.selectedOption = 'false';
    }

    bindEvents(){     
        $(`${constants.DIALOG_ID} input.action-selector`).on('click', (e)=>{
            const newVal = e.currentTarget.value;
            this.selectedOption = newVal;
        });
    }

    render(){
        return new Promise((resolve, reject) => {
            const settings = this.settings;

            settings.buttons = [
                {
                    text: 'Ok',
                    'class':'applyPermissions',
                    click: () => {
                        resolve(this.selectedOption);
                        this.closeModal();
                    }
                },
                {
                    text: 'Cancel',
                    click: () => {
                        resolve("cancel");
                        this.closeModal();
                    }
                }
            ];

            settings.open = () => {
                $(`input.action-selector[value='false']`).prop("checked", true);
                this.bindEvents();
            };

            if(this.template) {
                this.$el.html(this.template(this.model.toJSON()));
            }
            super.render();

        });
    }
}

export default ApplyPermissionToActionsModal;